import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { updatePackageReq } from '../packageReqService'
import { GetPackageReqsResponse } from '../types/GetPkgReqsResponse'

export const useUpdatePackageReq = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePackageReq,
    onSuccess: (res, { packageReqId, ...updateData }) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS_FEES, res.packageId] })
      res.unitePackageIds?.forEach(id => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS_FEES, id] })
      })
      queryClient.setQueriesData<GetPackageReqsResponse>({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS], exact: false }, old => {
        const updatedData = {} as GetPackageReqsResponse
        if (!old) return old
        Object.keys(old).forEach(key => {
          if (!old[key as keyof GetPackageReqsResponse]) return
          updatedData[key as keyof GetPackageReqsResponse] = old[key as keyof GetPackageReqsResponse].map(item =>
            item.id === packageReqId ? { ...item, ...updateData } : item
          )
        })
        return updatedData
      })
    },
  })
}
